<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="osha_sub.estab_name + ' :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link to="/subcontractors/osha-db">
                            <i class="fa fa-id-badge"></i> Subcontractors
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        {{ osha_sub.estab_name }}
                    </li>
                </ol>
            </h4>

            <div class="row mb-3">
                <div class="col-12">
                    <b-tabs class="nav-tabs-top mt-4 mb-3">
                        <b-tab active>
                            <template slot='title'>
                                <span class="d-sm-block d-none">
                                    General Info
                                </span>
                                <span class="d-sm-none d-block">
                                    Info
                                </span>
                            </template>
                            <b-card-body>
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="row mb-1">
                                            <label class="col text-muted text-right">Company Name:</label>
                                            <div class="col-md-8">
                                                {{ osha_sub.estab_name }}
                                            </div>
                                        </div>
                                        <div class="row mb-1">
                                            <label class="col text-muted text-right">SIC Code:</label>
                                            <div class="col-md-8">
                                                {{ osha_sub.sic_code }} ({{ osha_sub.description }})
                                            </div>
                                        </div>
                                        <div class="row mb-1">
                                            <label class="col text-muted text-right">NAICS Code:</label>
                                            <div class="col-md-8">
                                                {{ osha_sub.naics_code }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="row mb-1">
                                            <label class="col text-muted text-right">Site Address:</label>
                                            <div class="col-md-8">
                                                {{ osha_sub.site_address }}
                                            </div>
                                        </div>
                                        <div class="row mb-1">
                                            <label class="col text-muted text-right">Site City:</label>
                                            <div class="col-md-8">
                                                {{ osha_sub.site_city }}
                                            </div>
                                        </div>
                                        <div class="row mb-1">
                                            <label class="col text-muted text-right">Site State:</label>
                                            <div class="col-md-8">
                                                {{ osha_sub.site_state }}
                                            </div>
                                        </div>
                                        <div class="row mb-1">
                                            <label class="col text-muted text-right">Site Zip Code:</label>
                                            <div class="col-md-8">
                                                {{ osha_sub.site_zip }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-card-body>
                        </b-tab>
                        <b-tab>
                            <template slot='title'>
                                Inspections {{ `(${inspectionCount === null ? '-' : inspectionCount})` }}</span>
                            </template>
                            <b-card-body>
                                <v-server-table name="inspectionTable" ref="inspectionTable" :url="`/subcontractors/osha-db/inspections/${osha_sub_id}`" :columns="inspectionColumns" :options="inspectionOptions">

                                    <template slot="open_date" slot-scope="props">
                                        {{ props.row.open_date | moment('timezone', $store.state.user.timezone, "MM/DD/YYYY") }}
                                    </template>

                                    <template slot="insp_type" slot-scope="props">
                                        <template v-if="props.row.insp_type == 'A'">Accident</template>
                                        <template v-else-if="props.row.insp_type == 'B'">Complaint</template>
                                        <template v-else-if="props.row.insp_type == 'C'">Referral</template>
                                        <template v-else-if="props.row.insp_type == 'D'">Monitoring</template>
                                        <template v-else-if="props.row.insp_type == 'E'">Variance</template>
                                        <template v-else-if="props.row.insp_type == 'F'">Follow Up</template>
                                        <template v-else-if="props.row.insp_type == 'G'">Unprog Rel</template>
                                        <template v-else-if="props.row.insp_type == 'H'">Planned</template>
                                        <template v-else-if="props.row.insp_type == 'I'">Prog Related</template>
                                        <template v-else-if="props.row.insp_type == 'J'">Unprog Other</template>
                                        <template v-else-if="props.row.insp_type == 'K'">Prog Other</template>
                                        <template v-else-if="props.row.insp_type == 'L'">Other-L</template>
                                    </template>

                                    <template slot="insp_scope" slot-scope="props">
                                        <template v-if="props.row.insp_scope == 'A'">Complete</template>
                                        <template v-else-if="props.row.insp_scope == 'B'">Partial</template>
                                        <template v-else-if="props.row.insp_scope == 'C'">Records</template>
                                        <template v-else-if="props.row.insp_scope == 'D'">No Inspection</template>
                                    </template>

                                    <template slot="owner_type" slot-scope="props">
                                        <template v-if="props.row.owner_type == 'A'">Private</template>
                                        <template v-else-if="props.row.owner_type == 'B'">Local Govt</template>
                                        <template v-else-if="props.row.owner_type == 'C'">State Govt</template>
                                        <template v-else-if="props.row.owner_type == 'D'">Federal Govt</template>
                                    </template>

                                    <template slot="safety_hlth" slot-scope="props">
                                        <template v-if="props.row.safety_hlth == 'S'">Safety</template>
                                        <template v-else-if="props.row.safety_hlth == 'H'">Health</template>
                                    </template>

                                    <template slot="close_conf_date" slot-scope="props">
                                        {{ props.row.close_conf_date | moment('timezone', $store.state.user.timezone, "MM/DD/YYYY") }}
                                    </template>

                                    <template slot="close_case_date" slot-scope="props">
                                        {{ props.row.close_case_date | moment('timezone', $store.state.user.timezone, "MM/DD/YYYY") }}
                                    </template>

                                </v-server-table>
                            </b-card-body>
                        </b-tab>
                        <b-tab>
                            <template slot='title'>
                                Violations {{ `(${violationCount === null ? '-' : violationCount})` }}</span>
                            </template>
                            <b-card-body>
                                <v-server-table name="violationTable" ref="violationTable" :url="`/subcontractors/osha-db/violations/${osha_sub_id}`" :columns="violationColumns" :options="violationOptions">

                                    <template slot="viol_type" slot-scope="props">
                                        <template v-if="props.row.viol_type == 'S'">Serious</template>
                                        <template v-else-if="props.row.viol_type == 'W'">Willful</template>
                                        <template v-else-if="props.row.viol_type == 'R'">Repeat</template>
                                        <template v-else-if="props.row.viol_type == 'O'">Other</template>
                                    </template>

                                    <template slot="issuance_date" slot-scope="props">
                                        {{ props.row.issuance_date | moment('timezone', $store.state.user.timezone, "MM/DD/YYYY") }}
                                    </template>

                                    <template slot="abate_date" slot-scope="props">
                                        {{ props.row.abate_date | moment('timezone', $store.state.user.timezone, "MM/DD/YYYY") }}
                                    </template>

                                    <template slot="current_penalty" slot-scope="props">
                                        ${{ props.row.current_penalty }}
                                    </template>

                                    <template slot="initial_penalty" slot-scope="props">
                                        ${{ props.row.initial_penalty }}
                                    </template>

                                    <template slot="fta_penalty" slot-scope="props">
                                        ${{ props.row.fta_penalty }}
                                    </template>

                                    <template slot="contest_date" slot-scope="props">
                                        {{ props.row.contest_date | moment('timezone', $store.state.user.timezone, "MM/DD/YYYY") }}
                                    </template>

                                </v-server-table>
                            </b-card-body>
                        </b-tab>
                        <b-tab>
                            <template slot='title'>
                                Accidents/Injuries {{ `(${accidentInjuryCount === null ? '-' : accidentInjuryCount})` }}</span>
                            </template>
                            <b-card-body>
                                <v-server-table name="accidentInjuryTable" ref="accidentInjuryTable" :url="`/subcontractors/osha-db/accident-injuries/${osha_sub_id}`" :columns="accidentInjuryColumns" :options="accidentInjuryOptions">

                                    <template slot="degree_of_inj" slot-scope="props">
                                        <template v-if="props.row.viol_type == '1'">Fatality</template>
                                        <template v-else-if="props.row.viol_type == '2'">Hospitalized Injuries</template>
                                        <template v-else-if="props.row.viol_type == '3'">No Hospitalized Injuries</template>
                                    </template>

                                </v-server-table>
                            </b-card-body>
                        </b-tab>
                    </b-tabs>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                osha_sub_id: this.$route.params.id,
                osha_sub: {},
                inspectionCount: null,
                violationCount: null,
                accidentInjuryCount: null,
                inspectionColumns: ['activity_nr', 'open_date', 'insp_type', 'insp_scope', 'owner_type', 'safety_hlth', 'adv_notice', 'close_conf_date', 'close_case_date'],
                inspectionOptions: {
                    headings: {
                        activity_nr: 'Inspection Number',
                        open_date: 'Open Date',
                        insp_type: 'Inspection Type',
                        insp_scope: 'Scope',
                        owner_type: 'Ownership',
                        safety_hlth: 'Safety/Health',
                        adv_notice: 'Advanced Notice',
                        close_conf_date: 'Close Conference',
                        close_case_date: 'Close Case',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'activity_nr',
                    },
                    uniqueKey: 'id',
                    responseAdapter: (response) => {
                        this.$set(this, 'inspectionCount', response.data.count);
                        // WHYYYYYYY?????!!!!!
                        setTimeout(() => this.$forceUpdate(), 1);

                        //Send it
                        return response.data;
                    },
                },
                violationColumns: ['activity_nr', 'viol_type', 'standard', 'issuance_date', 'abate_date', 'current_penalty', 'initial_penalty', 'fta_penalty', 'contest_date'],
                violationOptions: {
                    headings: {
                        activity_nr: 'Inspection Number',
                        viol_type: 'Viol Type',
                        standard: 'Standard',
                        issuance_date: 'Issuance',
                        abate_date: 'Abatement Date',
                        current_penalty: 'Current Penalty',
                        initial_penalty: 'Initial Penalty',
                        fta_penalty: 'FTA Penalty',
                        contest_date: 'Contest Date',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'activity_nr',
                    },
                    uniqueKey: 'id',
                    responseAdapter: (response) => {
                        this.$set(this, 'violationCount', response.data.count);
                        // WHYYYYYYY?????!!!!!
                        setTimeout(() => this.$forceUpdate(), 1);

                        //Send it
                        return response.data;
                    },
                },
                accidentInjuryColumns: ['rel_insp_nr', 'nature_of_inj_value', 'event_type_value', 'evn_factor_value', 'hum_factor_value', 'occ_code_value', 'degree_of_inj'],
                accidentInjuryOptions: {
                    headings: {
                        rel_insp_nr: 'Inspection Number',
                        nature_of_inj_value: 'Nature',
                        event_type_value: 'Type',
                        evn_factor_value: 'Environmental Factor',
                        hum_factor_value: 'Human Factor',
                        occ_code_value: 'Occupation',
                        degree_of_inj: 'Degree',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'rel_insp_nr',
                    },
                    uniqueKey: 'osha_db_accident_injuries.id',
                    responseAdapter: (response) => {
                        this.$set(this, 'accidentInjuryCount', response.data.count);
                        // WHYYYYYYY?????!!!!!
                        setTimeout(() => this.$forceUpdate(), 1);

                        //Send it
                        return response.data;
                    },
                },
            }
        },

        methods: {
            getSubcontractor: function() {
                //Get the data
                this.$http
                    .get(`subcontractors/osha-db/view/${this.osha_sub_id}`)
                    .then(response => {
                        //Set all the data
                        this.osha_sub = response.data;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },
        },
        mounted() {
            //Get the subcontractors
            this.getSubcontractor();
        }
    }
</script>

<style>
    .no-form-group-margin .form-group {
        margin-bottom: 0;
    }
</style>
